import React, { useEffect } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import {
  IExpandedMailingRule,
  CorporateTypeEnum,
} from 'interfaces/MailingRule';

import MultiOptionField from 'components/MultiOptionField';
import SystemsField from './SystemsField';

import { IMailingRuleSubformProps } from '../../interfaces';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const SubFormMultipleSelections: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const {
    list: { mailingRuleCustomerTypes },
  } = useSelector((state: RootState) => state.parameters);
  const {
    list: { mailingRuleCorporateTypes },
  } = useSelector((state: RootState) => state.parameters);
  const { parameters } = useSelector((state: RootState) => state);
  const {
    list: { mailingRuleBillingTypes },
  } = useSelector((state: RootState) => state.parameters);
  const {
    list: { mailingRulePropensity },
  } = useSelector((state: RootState) => state.parameters);

  const { values, setFieldValue } = useFormikContext<IExpandedMailingRule>();
  const isCorporate = values.customerType.includes('PJ');

  useEffect(() => {
    setFieldValue(
      'corporateType',
      values.customerType.includes('PJ')
        ? Object.values(CorporateTypeEnum)
        : [],
      false,
    );
  }, [values.customerType, setFieldValue]);

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Tipo de pessoa</Typography>
        </Grid>
        <Grid
          data-cy="sub-form-multiple-selections__check-group--customer-type"
          item
          xs={12}
        >
          <MultiOptionField
            name="customerType"
            options={mailingRuleCustomerTypes}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>

      {isCorporate && (
        <Grid
          item
          xs={12}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <Typography variant="h6">Tipo de pessoa jurídica</Typography>
          </Grid>
          <Grid
            data-cy="sub-form-multiple-selections__check-group--corporate-type"
            item
            xs={12}
          >
            <MultiOptionField
              name="corporateType"
              hasSelectAll
              options={mailingRuleCorporateTypes}
              disabled={!isEditable}
            />
          </Grid>
        </Grid>
      )}

      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Propensão</Typography>
        </Grid>
        <Grid
          data-cy="sub-form-multiple-selections__check-group--propensity"
          item
          xs={12}
        >
          <MultiOptionField
            name="propensity"
            hasSelectAll
            options={mailingRulePropensity}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>

      <SystemsField
        data-cy="sub-form-multiple-selections__check-group--system-field"
        isEditable={isEditable}
      />

      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Forma de pagamento</Typography>
        </Grid>
        <Grid
          data-cy="sub-form-multiple-selections__check-group--billing-type"
          item
          xs={12}
        >
          <MultiOptionField
            name="billingType"
            hasSelectAll
            options={mailingRuleBillingTypes}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">UF de cobrança</Typography>
        </Grid>
        <Grid
          data-cy="sub-form-multiple-selections__check-group--uf"
          item
          xs={12}
        >
          <MultiOptionField
            name="uf"
            hasSelectAll
            options={parameters.list.states.map((uf) => ({
              value: uf,
              label: uf,
            }))}
            direction="row"
            xs={1}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SubFormMultipleSelections;
